<template>
  <div>
    <FinancialManagementNew v-if="showNewWithdrawal" />
    <FinancialManagementOld v-else />
  </div>
</template>

<script>
import FinancialManagementNew from "@/components/FinancialManagementNew/Index"
import FinancialManagementOld from "@/components/FinancialManagementOld/Index"

export default {
  data () {
    return {
      showNewWithdrawal: true
    }
  },
  mounted() {
    let show_new_withdrawal = localStorage.getItem("show_new_withdrawal");
    this.showNewWithdrawal = show_new_withdrawal === "true";
  },
  components: {
    FinancialManagementNew, FinancialManagementOld
  }
}
</script>
